// src/components/admin/admin-review-appt-req.js

import React, { useState, Fragment, useEffect, useContext } from 'react';
import { RestHelper } from '../../helper/restHelper'
import { UserContext } from "../../app"
import { AdminEditRequest, AdminViewRequest, NotaryPaidImage, AdminDisplaySimilarOrders} from "../../components/admin"
import { ProfilePopupOverlay, GeneralUploadStatus, TitleUploadStatus } from '../../components';



const AdminReviewApptRequests = (profileEmail) => {
    const {userProfile, setUser } = useContext(UserContext)
    const [apiRes, setApiRes] = useState([])
    const [apiUpdate, setApiUpdate] = useState([])
    const [orgList, setOrgList] = useState ({})
    const [initialFirmList, setInitialFirmList] = useState([])
    const [searchStatus, setSearchStatus] = useState('Open')
    const [selectedFirmId, setSelectedFirmId] = useState()
    const [showResults, setShowResults] = useState(false)
    const [viewRequest, setViewRequest] = useState(false)
    const [showOpen, setShowOpen] = useState(false)
    const [requestId, setRequestId] = useState('')
    const [showNotaryPopup, setShowNotaryPopup] = useState(false)
    const [notaryEmail, setNotaryEmail] = useState('')
    const api = RestHelper()
   
    useEffect (() => {
      getFirmList();
    }, [apiUpdate, setApiUpdate]);
    
    useEffect(() => {
        const idArray = ['firm']
        const firmArray = initialFirmList
        const firmDict = {}
        firmArray.forEach(value => {
            firmDict[value['org_name']] = value['org_id']
        })
        idArray.forEach(value => {
            const firmVar = document.getElementById(value)
            firmArray.forEach(value2 => {
                const option = document.createElement('option')
                option.innerHTML = value2['org_name']
                firmVar.appendChild(option)
                setOrgList({
                    ...orgList,
                    firmDict
                })
            })
        })
    },[initialFirmList,setInitialFirmList]);

    const changeView = () => {
      setViewRequest(false)
      setShowResults(true)
      getApi()
    }
    const getRequest = (data) => {
      setRequestId(data.RequestId)
      setViewRequest(true);
      setShowResults(false)
    }

    // if Check Pending Requests is selected, we'll query for pending requests
  
    const getApi = () => {
      const options = {}
      const passedData = {'firmId' : selectedFirmId, 'status' : searchStatus}
      api
          .postCreate('/get-admin-pending-appts', options, passedData)
          .then(res => setResponse(res))
          .catch(err => console.log(err))
      setShowResults(true)
      }

    const getFirmList = () => {
     const options = {}
     const passedData = {'activeUser' : userProfile.profileEmail}
     api
        .postCreate('/get-firm-list', options, passedData)
        .then(res => setInitialFirm(res))
        .catch(err => console.log(err))
    }

    const setResponse = (res) => {
      setApiRes(res)
      if (res[0]['Status'] == 'Open'){
        setShowOpen(true)
      }
      else {
        setShowOpen(false)
      }
    }

    const dateFormat = (inputDate) => {
      const dateArray = inputDate.split("-")
      const date = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0]
      return date
    }
    const setInitialFirm = (res) => {
      var firmArray = [{'org_name': 'All', 'org_id': 1000}].concat(res['firms'])
      setInitialFirmList(firmArray)
      setSelectedFirmId(1000)
    }

      const updateNotary = (props) => {
        const options = {}
        api
            .postCreate('/update-notary-registration', options, props)
            .then(res => setResponse(res))
            .catch(err => console.log(err))
        }  
    const selectFirm = (firm) => {
        const firmInfo = document.getElementById(firm.target.id)
        setSelectedFirmId(orgList['firmDict'][firmInfo.value])
    }

    const selectStatus = (status) => {
        const searchPref = document.getElementById(status.target.id)
        setSearchStatus(searchPref.value)
    }

    function clearModal() {
      setShowNotaryPopup(false)
    }

    function getProfile(e) {
      setNotaryEmail(e)
      setShowNotaryPopup(true)
    }
  
    function confirmAction(e) {
      //do nothing here
    }

    const onClickHandler = () => {
      getApi()
    }
    const onSubmitHandler = (action) => {
        const checklist = []
        const approval = {'action': action}
        apiRes.forEach(item =>{
            const checkValue = document.getElementById(item.email)
            if (checkValue.checked){
                checklist.push({'email' : item.email})
            }
        })
        if (checklist.length > 0) {
            updateNotary([approval,checklist])
        }
    }
 
    return(
     <div className="w-full px-2 sm:px-4 lg:px-6 flex-grow-1">
          <div className="mt-3">
            <div className='flex flex-wrap gap-4 items-end'>
             <div className="mb-3 mt-2">
               <label htmlFor="firm" className='block text-sm font-medium text-neutral-700 mb-1'>Firm</label>
                  <select className='w-48 px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500' id="firm" onChange={(e)=>selectFirm(e)}></select>
             </div>
             <div className="mb-3 mt-2">
               <label htmlFor="status" className='block text-sm font-medium text-neutral-700 mb-1'>Status</label>
                  <select className='w-40 px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500' id="status" onChange={(e)=>selectStatus(e)}>
                    <option value='Open'>Open</option>
                    <option value='Pending'>Pending</option>
                    <option value='Scheduled'>Scheduled</option>
                    <option value='Paused'>On Hold</option>
                    <option value='Completed'>Completed</option>
                    <option value='Canceled'>Canceled</option>
                  </select>
             </div>
              <button type='submit' className='bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded mb-3' onClick={()=>onClickHandler()}>Search</button>
            </div>
            {showResults &&
            (<div>
            <h6 className="text-neutral-600 mb-3">Here are the results of your appointment search:</h6>
            <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-neutral-50 border-b border-neutral-200">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700">Appt Name</th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700">Files</th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700">Downloaded</th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700"></th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700">Status</th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700"></th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700">Signing Agent</th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700">Firm</th>
                      <th className="px-4 py-3 text-left font-semibold text-neutral-700">Date</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-neutral-100">
                    {apiRes.map((items =>
                      <tr key={items.RequestId} className="hover:bg-neutral-50 transition-colors">
                        <td className="px-4 py-3">
                          <button className="text-blue-600 hover:text-blue-800 hover:underline font-medium" type="button" onClick={() => getRequest(items)}>{items.Appt_Name}</button>
                        </td>
                        <td className="px-4 py-3"><TitleUploadStatus filesAttached={items.filesAttachedCount} filesUploaded={items.fileUploadStatus}/></td>
                        <td className="px-4 py-3"><GeneralUploadStatus action='write' confirm={items.notaryReviewed}/></td>
                        <td className="px-4 py-3"><GeneralUploadStatus action='messages' confirm={items.unreadMessages}/></td>
                        <td className="px-4 py-3 text-neutral-700">{items.Status}</td>
                        <td className="px-4 py-3"><NotaryPaidImage notaryPaid={items.notaryPaid} notaryPaidTime={items.notaryPaidTime}/></td>
                        <td className="px-4 py-3">
                          <button className="text-blue-600 hover:text-blue-800 hover:underline font-medium" type="button" onClick={() => getProfile(items)}>{items.NotaryName}</button>
                        </td>
                        <td className="px-4 py-3 text-neutral-700">{items.Firm_Name}</td>
                        <td className="px-4 py-3 text-neutral-700">{dateFormat(items.Appt_Date)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>)}
          {viewRequest &&
           (<div className='w-full mb-3'>
            <div className='flex justify-start mb-4'>
              <button
                className="flex items-center gap-2 text-neutral-600 hover:text-neutral-800 font-medium py-2 px-3 rounded-lg hover:bg-neutral-100 transition-colors"
                aria-label="Close"
                onClick={() =>changeView()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to Results
              </button>
            </div>
            <Fragment>
              {showOpen
              ? <AdminEditRequest requestId={requestId}/>
              : <AdminViewRequest requestId={requestId} searchStatus={searchStatus}/>
            }
            {showOpen&&<AdminDisplaySimilarOrders summaryData={requestId} closeWindow={() =>changeView()} />}

            </Fragment>
          </div>)}
          <Fragment>
            {showNotaryPopup && <ProfilePopupOverlay clearModal={clearModal} confirmAction={confirmAction} email={notaryEmail.Notary} />}
          </Fragment>
        </div>
    </div>
    );
}
export default AdminReviewApptRequests;